/**
 * The file a governed export produced, rebuilt from the snapshot it locked.
 *
 * Both the lock itself and the submission pack's artefact list hand the file
 * over, and both must build it from the recorded snapshot, not the live buffer.
 *
 * @module export/snapshot-artefact
 */

import { resolveDescriptorVariant } from "@/export/descriptor-variant";
import { downloadJson } from "@/export/json";
import { downloadScheduleDocx } from "@/export/schedule-docx";
import { exportProgrammeDescriptorWord } from "@/export/word";
import type { ExportFormat } from "@/server/types";
import type { Programme } from "@/types";
import type { ProviderContact } from "@/types/provider";

export async function downloadSnapshotArtefact(
  format: ExportFormat,
  data: Programme,
  programmeLeadContact?: ProviderContact,
): Promise<void> {
  if (format === "descriptor") {
    await exportProgrammeDescriptorWord(
      data,
      resolveDescriptorVariant(data),
      undefined,
      programmeLeadContact,
    );
  } else if (format === "schedule") {
    await downloadScheduleDocx(data);
  } else {
    downloadJson(data);
  }
}
